import {ArrowDownWideNarrow} from 'lucide-react';

export const SortDropdown = ({
  isAdmin,
  showDropdown,
  sortBy,
  onToggle,
  onSortChange,
}) => {
  const options = [
    {value: 'alphabetical', label: 'Alphabetical'},
    {
      value: 'most_completed',
      label: isAdmin ? 'Most to Least % Completed' : 'Most to Least Completed',
    },
    {
      value: 'least_completed',
      label: isAdmin ? 'Least to Most % Completed' : 'Least to Most Completed',
    },
  ];

  return (
    <div className='baseline-dropdown-container'>
      <button onClick={onToggle} className='baseline-button'>
        <ArrowDownWideNarrow className='baseline-button-icon' />
        Sort
      </button>
      {showDropdown && (
        <div className='baseline-dropdown baseline-dropdown-sort'>
          <div className='baseline-dropdown-content'>
            <div className='baseline-dropdown-note'>Sort</div>
            <div className='baseline-dropdown-options'>
              {options.map((option) => (
                <label key={option.value} className='baseline-dropdown-option'>
                  <input
                    type='radio'
                    name='sort'
                    value={option.value}
                    checked={sortBy === option.value}
                    onChange={(e) => onSortChange(e.target.value)}
                  />
                  <span>{option.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
